{
  "error": {
    "server_connection_failed": "Mistókst sambandið við þjón."
  },
  "term": {
    "affects_all_instances": "Affects all {count} instances",
    "affects_this_instance_only": "Affects only this instance",
    "application": "Forrit",
    "attributes": "Einkenni",
    "bytes": "Bæti",
    "cancel": "Hætta við",
    "clear": "Tæma",
    "cleared": "Tæmt",
    "close": "Ljúka",
    "confirm": "Staðfesta",
    "delete": "Eyđa",
    "deleted": "Eytt",
    "duration": "Tímalengd",
    "event": "Atburður",
    "ever": "alltaf",
    "executing": "Í vinnslu…",
    "execution_failed": "Framkvæmd mistekist.",
    "execution_successful": "Framkvæmd farsæl.",
    "failed": "Mistekist",
    "float": "Float",
    "hours": "{count} klst. | {count} klst.",
    "instances": "Eintök",
    "integer": "Integer",
    "milliseconds": "Millisekúndar",
    "minutes": "{count} Mínúta | {count} Mínútur",
    "percent": "prósent",
    "name": "Nafn",
    "operations": "Rökaðgerðir",
    "save": "Vista",
    "stacktrace": "Stacktrace",
    "suppress": "Hunsa",
    "time": "Tími",
    "unsuppress": "Endurvekja",
    "username": "Notandanafn"
  },
  "time_short": {
    "unknown": "óþekkt",
    "milliseconds": "{count}ms",
    "seconds": "{count}sek",
    "minutes": "{count}mín",
    "hours": "{count}klst",
    "days": "{count}dag",
    "weeks": "{count}vika",
    "months": "{count}mán",
    "years": "{count}ár"
  }
}
